namespace $.$$ {
	export class $shm_hitalama_map_fontsize extends $.$shm_hitalama_map_fontsize {
		
		font_size_selected( next?: string ): string {
			if( next ) this.font_size( Number( next ) )
			return next ?? ''
		}

		font_size_suggests(): readonly ( string )[] {
			return this.font_size_options().map( n => n.toString() )
		}

		font_size_inc() {
			const current = this.font_size()
			const options = this.font_size_options()
			const next = options.find( n => n > current )
			if( next ) this.font_size( next )
		}

		font_size_dec() {
			const current = this.font_size()
			const options = this.font_size_options()
			const next = options.findLast( n => n < current )
			if( next ) this.font_size( next )
		}
		
	}
}
